import {
  instance as axios,
  instanceDownloadFile as axiosDF,
} from "../../configs/axios";

export default {
  create: (options = { params: {} }) => axios.post(`/Promotion`, options),
  offerList: (options = { params: {} }) =>
    axios.post(`/Promotion/OfferList`, options),
  checkOfferDescription: (options = { params: "" }) =>
    axios.post(`/Promotion/checkOfferDescription`, options),
  getById: (id) => axios.get(`/Promotion/${id}`),
  getFilePromotionSku: (id) => axiosDF.get(`/Promotion/FilePromotionSku/${id}`),
  getStartPromotion: () => axios.get(`/Promotion/StartDatePromotion`),
  getDateTimeNow: () => axios.get(`/Promotion/DateTimeNow`),
  sendSSOPayloadToETP: () => axios.post(`Promotion/SendSSOPayloadToETP`),
  getXlsxConflict: (ruleId) => axiosDF.get(`/Promotion/GetXlsxConflict/${ruleId}`),
};
